import * as React from 'react';
import clx from 'classnames';
import { Col, Row } from 'antd';
import { ColProps } from 'antd/lib/col';

export interface PageMainColumnProps extends ColProps {
  orderMobile?: number;
  orderDesktop?: number;
  isAdmin?: boolean;
}

/**
 * Colonna principale della pagina frontend con larghezza responsive
 */
export function PageMainColumn(props: PageMainColumnProps) {
  const { orderMobile, orderDesktop, isAdmin, ...othersProps } = props;
  return (
    <Col
      style={{ margin: 'auto' }}
      xs={{ span: 24, order: orderMobile ?? 2 }}
      md={{ span: isAdmin ? 14 : 16, order: orderDesktop ?? 1 }}
      lg={{ span: isAdmin ? 15 : 17, order: orderDesktop ?? 1 }}
      {...othersProps}
    />
  );
}
